export type InvoicePriceType = 'net' | 'gross'

export interface InvoiceFormData {
  vat_option: string
  net_price?: number
  price: string
  price_type: InvoicePriceType
  invoice_number: string
  invoice_date: string
  delivery_date: string
  language: string
  additional_text: string
  currency_code: string
  payment_method: string
  payment_due_date: string
  motorbike_id?: string | number
  vin: string
  motorbike_name?: string
  motorbike_year?: string
  motorbike_mileage?: number | null
  client_id?: string | number
  client_name?: string
  client_tax_number?: string
  client_street?: string
  client_house_number?: string
  client_zip_code?: string
  client_place?: string
}

const requiredTextFields = [
  'invoice_number',
  'language',
  'invoice_date',
  'delivery_date',
  'vat_option',
  'price',
  'currency_code',
  'payment_method',
  'payment_due_date'
] as const

const hasId = (value: string | number | undefined): boolean => {
  if (typeof value === 'number') {
    return value !== 0
  }
  return typeof value === 'string' && value.trim() !== '' && value !== '0'
}

export const validateInvoiceForm = (values: InvoiceFormData): Partial<Record<keyof InvoiceFormData, string>> => {
  const errors: Partial<Record<keyof InvoiceFormData, string>> = {}

  requiredTextFields.forEach((field) => {
    const value = values[field]
    if (typeof value !== 'string' || value.trim() === '') {
      errors[field] = 'required'
    }
  })

  if (!hasId(values.client_id)) {
    errors.client_id = 'required'
  }
  if (!hasId(values.motorbike_id)) {
    errors.motorbike_id = 'required'
  }
  if (typeof values.vin !== 'string' || values.vin.trim() === '') {
    errors.vin = 'required'
  }

  return errors
}
